import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const StyledTransactionRow = styled.div<{
  marginTop?: boolean;
  clickable?: boolean;
}>`
  display: flex;
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};
  align-items: center;
  justify-content: space-between;
  max-width: 800px;
  position: relative;
  margin-top: ${({ marginTop = false, theme }): string =>
    marginTop
      ? `calc(${theme.spacing_unit_x2} + 1.25rem)`
      : `${theme.spacing_unit_x1}`};
  border-bottom: ${({ theme }): string => `1px solid ${theme.palette_gray_5}`};
  padding-bottom: ${({ theme }): string => theme.spacing_unit_x2};

  ${({ clickable }): FlattenSimpleInterpolation =>
    clickable
      ? css`
          &:hover {
            cursor: pointer;
          }
        `
      : css``}
`;

export const StyledTransactionRowItem = styled.div<{
  align?: 'left' | 'right';
  hasTooltip?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }): string => {
    return theme.spacing_unit_x1;
  }};
  text-align: ${({ align }): string => align || 'left'};
  align-self: ${({ align }): string =>
    align === 'right' ? 'flex-end' : 'flex-start'};
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};

  ${({ theme, hasTooltip }): FlattenSimpleInterpolation => css`
    @media (max-width: ${theme.breakpoints_sm}) {
      ${hasTooltip ? 'flex-direction: column;' : ''}
    }
  `}
`;
